<template>
  <section>
    <h2 class="title">News</h2>
    <PostListItem
      v-for="post in posts"
      :title="post.fields.title"
      :description="post.fields.description"
      :imageUrl="post.fields.mainImage.fields.file.url"
      :body="post.fields.body"
      :date="post.fields.publishDate"
      :key="post.createdAt"/>
  </section>
</template>

<script>
import ApiPosts from '@/api/posts'
import PostListItem from '@/components/PostListItem'
export default {
  components: {
    PostListItem
  },
  data () {
    return {
      posts: []
    }
  },
  created () {
    let locale = 'en-US'
    if (window.localStorage.getItem('language')) {
      switch (window.localStorage.getItem('language')) {
        case 'fr':
          locale = window.localStorage.getItem('language')
      }
    }
    console.log(locale)
    ApiPosts
      .get
      .getPosts(locale)
      .then((response) => {
        this.posts = response.body.items
      })
      .catch(console.error)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PostList.vue